(function ($) {
    "use strict";
    $(function () {
        $(".js-detailed-filters-button").on("click", function () {
            $(".js-detailed-filters").slideToggle("fast");
            $(this).toggleClass("open");

            $("body").toggleClass("detailed-filters-open");
        });
    });
})(jQuery);
